<template>
    <div class="main-con el-main">
        <nav-breadcrumb :menu="[{label: '助贷月还款明细'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
                :sort.sync="sort"
                :is-pagination-show="false"
                ref="tableData"
            />
        </div>
        <el-dialog :visible.sync="repayFormDialogVisible3" title="还款记录" width="70%">
            <data-table
                :table-data="attData2"
                :columns="attcolumns2"
                :is-pagination-show="false"
            />

          <!--  <table-build
                v-model="attData2"
                :columns="attcolumns2"
                :is-pagination-show="false"
            />-->
            <form-build
                :form-data="attDatShow"
                :form-columns="attDatShowColumns"
            ></form-build>


            <div class="tr xzmt">
                <el-button size="small" type="" @click="closeDialog()">关闭</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import moment from 'moment'
    import {xmlBuildQuery, xmlBuildSort} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "RepaymentPlanList",
        data(){
            return{
                applicationStatus: 'Pending Approval',
                repayFormDialogVisible3:false,
                roleData:{},
                dealerOptions:[],
                attcolumns2:[

                    {
                        label: '实还日期',
                        field: 're__repayDate',
                        formatter:  (r,c,v) => {
                            if(v)
                                return moment(v).format('YYYY-MM-DD')
                            else
                                return ''
                        }
                    },
                    {
                        label: '实还本金',
                        field: 're__principalAmount',
                        formatter: (r,c,v) =>{
                            if(v)
                                return formatMoney(v)
                            else
                                return ''
                        },
                    },
                    {
                        label: '实还利息',
                        field: 're__interestAmount',
                        formatter: (r,c,v) =>{
                            if(v)
                                return formatMoney(v)
                            else
                                return ''
                        },
                    },
                    {
                        label: '备注',
                        field: 're__remarks',
                    },
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                attData2: {
                    count: 0,
                    data: []
                },
                sort: {
                    fields: ['fi__transactionNo', 'rex__balanceAmount'],
                    default: {
                        prop: 'fi__transactionNo',
                        order: 'ascending'
                    },
                    params: {}
                },
                dealerTypeOptions:[],
                page: 1,
                pageSize: 20,
                actions: [
                    {
                        label: '导出',
                        class: 'el-icon-download el-button--primary',
                        clickHandler:()=> {
                            this.$refs.tableData.$refs.DataTableFilterForm.$refs.DataTableFilterForm.validate(valid=> {
                                if(valid) {
                                    let routeData = this.$router.resolve({
                                        path: '/ix/fang/financing/lender/reporting/RepaymentPlan.List?format=xls',
                                        query: Object.assign({
                                            pageSize:0,
                                            'repayDate':this.filters.form.plan__repayDate,
                                        }, {}, xmlBuildQuery(this.filters))
                                    });
                                    window.open(routeData.href.replace('#/', '/'), '_blank');
                                }
                            })
                        }
                    }
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        l__lenderId:'',
                        fi__customerName:'',
                        plan__repayDate:'',
                        fi__transactionNo:'',
                        c__customerContactNo:'',
                        fi__repaymentFormula:'',
                        plan__repaymentStatus:'',
                        d__dealerId:'',
                    },
                    rules: {
                        plan__repayDate:{
                            required:true,
                            message: '不能为空'
                        }
                    },
                    columns: [
                        {
                            label: '资方',
                            component: 'el-select',
                            field: 'l__lenderId',
                            options:[],
                            span: 12
                        },
                        {
                            label: '渠道商',
                            component: 'el-select',
                            field: 'd__dealerId',
                            options:[],
                            span: 12
                        },
                        {
                            label: '应还款月',
                            component: 'el-date-picker',
                            field: 'plan__repayDate',
                            op:'gteq',
                            type: 'month',
                            valueFormat:'yyyy-MM-01 00:00:00',
                            span: 12,

                        },
                        {
                            label: '贷款编号',
                            component: 'el-input',
                            field: 'fi__transactionNo',

                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'fi__customerName',

                        },
                        {
                            label: '还款状态',
                            component: 'el-select',
                            field: 'plan__repaymentStatus',
                            options: [
                                {
                                    label: '全部',
                                    value: ''
                                },
                                {
                                    label: '未还',
                                    value: 'Pending'
                                },
                                {
                                    label: '已还',
                                    value: 'Settled'
                                },
                            ],
                            op: 'eq',
                            span: 12
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    },
                    onReset: ()=> {
                        this.filters.form = {
                            l__lenderId:'',
                            fi__customerName:'',
                            plan__repayDate:'',
                            pan__sequenceNo:'',
                        }
                        this.tableData= {
                            count: 0,
                            data: []
                        }
                    }
                },
                balanceAmounts:0,
                principalAmount:0,
                interestAmount:0,
                subtotalAmount:0,
                balanceAmount:0,
                attDatShow:{
                    plan__repayDate:'',
                    plan__principalAmount:'',
                    plan__principalAmount:'',
                    plan__principalBalance:'',
                    principalAmount:0,
                    interestAmount :0,
                },
            }
        },
        computed:{
            columns: function(){
                return [
                    {
                        name:'序号',
                        type: 'index'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'fi__customerName'
                    },
                    {
                        label: '渠道商',
                        field: 'd__dealerName'
                    },
                    {
                        label: '资方',
                        field: 'l__lenderName'
                    },

                    {
                        label: '贷款金额',
                        field: 'fi__totalAmount',
                        formatter: function (r,c,v) {
                            if(v)
                                return formatMoney(v)
                            else
                                return ''
                        }
                    },
                    {
                        label: '期初贷款余额',
                        field: 'plan__principalBalance',
                        formatter: function (r,c,v) {
                            if(v)
                                 return formatMoney(v)
                            else
                                return ''
                        }
                    },
                    {
                        label: '起息日',
                        field: 'plan__startDate',
                        formatter: function (r,c,v) {
                            if(v)
                                return moment(v).format('YYYY-MM-DD')
                            else
                                return ''
                        }
                    },
                    {
                        label: '止息日',
                        field: 'plan__endDate',
                        formatter: function (r,c,v) {
                            if(v)
                                return moment(v).format('YYYY-MM-DD')
                            else
                                return ''
                        }
                    },
                    {
                        label: '应还款日',
                        field: 'plan__repayDate',
                        formatter: function (r,c,v) {
                            if(v)
                                return moment(v).format('YYYY-MM-DD')
                            else
                                return ''
                        }
                    },
                    {
                        label: '计息天数',
                        field: 'plan__days'
                    },
                    {
                        label: '利率(%)',
                        field: 'fi__interestRate',
                        formatter: function (r,c,v) {
                            if(v)
                                return (v*100).toFixed(3)+'%(年利率)'
                            else
                                return ''
                        }
                    },
                    {
                        label: '应还本金',
                        field: 'plan__principalAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)
                        }
                    },
                    {
                        label: '应还利息',
                        field: 'plan__interestAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(v)
                        }
                    },
                    {
                        label: '小计',
                        field: 'plan__subtotalAmount',
                        formatter: function (r,c,v) {
                            return formatMoney(parseFloat(r.plan__principalAmount)+parseFloat(r.plan__interestAmount))
                        }
                    },

                    {
                        label: '还款状态',
                        field: 'plan__repaymentStatus',
                        render:  (r,c,v)=> {
                            if(v){
                                if(parseInt(r.plan__dayNext)>25&&r.plan__repaymentStatus=='Pending'){

                                    return  Status2CN('plan__'+v)+'<div class="Htitle-text color-danger">即将超宽限期</div>'
                                }else{
                                    return  Status2CN('plan__'+v)
                                }
                            }else{
                                return ''
                            }

                        },
                        width: '140px'

                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '还款记录',
                                class: 'el-icon-s-order',
                                clickHandler: (index, row)=>{
                                    this.attDatShow.plan__repayDate = row.plan__repayDate
                                    this.attDatShow.plan__principalAmount = row.plan__principalAmount
                                    this.attDatShow.plan__interestAmount = row.plan__interestAmount
                                    this.attDatShow.plan__principalBalance = row.plan__principalBalance
                                    this.attDatShow.principalAmount = 0
                                    this.attDatShow.interestAmount = 0

                                    this.getData2(row.plan__entryId)
                                    this.repayFormDialogVisible3 = true
                                }
                            },
                        ]
                    }

                ]
            },
            attDatShowColumns(){
                return [
                    {
                        label: '还款日期',
                        field: 'plan__repayDate',
                        formatter: function (r,v) {
                            if(v)
                                return moment(v).format('YYYY-MM-DD')
                            else
                                return ''
                        },
                        span:8
                    },
                    {
                        label: '应还本金',
                        field: 'plan__principalAmount',
                        formatter: function (r,v) {
                            return formatMoney(v)
                        },
                        span:8
                    },
                    {
                        label: '应还利息',
                        field: 'plan__interestAmount',
                        formatter: function (r,v) {
                            return formatMoney(v)
                        },
                        span:8
                    },
                    {
                        label: '已还本金',
                        field: 'principalAmount',
                        formatter: function (r,v) {
                            return formatMoney(v)
                        },
                        span:8
                    },
                    {
                        label: '已还利息',
                        field: 'interestAmount',
                        formatter: function (r,v) {
                            return formatMoney(v)
                        },
                        span:8
                    },
                    {
                        label: '余额',
                        field: 'plan__principalBalance',
                        formatter: function (r,v) {
                            return formatMoney(v)
                        },
                        span:8
                    },
                ]
            },
            filterParams: {
                get: function() {
                    return {

                    }
                },
                set:function (newVal) {

                }
            }
        },
        watch: {
            filterParams: function () {
                this.getData()
            },
            sort: function () {
                this.getData()
            }
        },

        mounted() {
            this.getLenderList()
            this.getDealerList()
        },
        methods: {
            getData2: function (entryId) {
                xhr.getRepaymentFangList(
                    Object.assign({pageSize:0,
                        'xlist.search.plan.entryId' : entryId,
                        'xlist.search.plan.entryId.op' : 'eq',}, {},{}),
                    res=> {
                        try {
                                this.attData2 = res.data
                                let principalAmount = 0
                                let interestAmount = 0
                                this.attData2.data.forEach( item=>{
                                    principalAmount = parseFloat(principalAmount) + parseFloat(item.re__principalAmount)
                                    interestAmount = parseFloat(interestAmount) + parseFloat(item.re__interestAmount)
                                })

                                this.attDatShow.principalAmount = principalAmount
                                this.attDatShow.interestAmount = interestAmount
                        } catch (e) {

                        }
                    })
            },

            getData: function () {
                xhr.getRepaymentPlanFangList(
                    Object.assign({pageSize:0}, {}, xmlBuildQuery(this.filters), xmlBuildSort(this.sort.params)),
                    res => {
                        try {

                            this.principalAmount = 0
                            this.interestAmount = 0
                            this.subtotalAmount = 0



                            this.tableData = res.data
                            this.tableData.data.forEach(item=>{
                                if(item.plan__principalAmount){
                                    this.principalAmount = this.principalAmount +parseFloat(item.plan__principalAmount)*10000
                                }
                                if(item.plan__interestAmount){
                                    this.interestAmount = this.interestAmount +parseFloat(item.plan__interestAmount)*10000
                                }
                                if(item.plan__subtotalAmount){
                                    this.subtotalAmount = this.subtotalAmount +parseFloat(item.plan__subtotalAmount)*10000
                                }

                            })
                            this.tableData.data.push({
                                lineNo:'合计：',
                                fi__customerName:'共'+this.tableData.count+'笔',

                                plan__principalAmount : parseFloat(this.principalAmount/10000).toFixed(2),
                                plan__interestAmount : parseFloat(this.interestAmount/10000).toFixed(2),
                                plan__subtotalAmount : parseFloat(this.subtotalAmount/10000).toFixed(2),

                            })

                        } catch (e) {

                        }
                    })
            },
            getLenderList: function () {
                xhr.getLenderList(
                    Object.assign({pageSize:0}, this.filterParams, {}),
                    res=> {
                        try {
                            this.filters.columns[0].options = res.data.data.map(item=>{
                                return {
                                    label: item.d__lenderName,
                                    value:item.d__lenderId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            getDealerList: function () {
                xhr.getDealerList(
                    Object.assign({
                        'xlist.search.d.forLender':'Y',
                        'xlist.search.d.forLender.op':'eq',
                        pageSize:0}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.filters.columns[1].options = res.data.data.map(item=>{
                                return {
                                    label: item.d__dealerName,
                                    value:item.d__dealerId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            closeDialog: function () {
                this.repayFormDialogVisible3 =false
            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/RepaymentPlanList.vue